import { put, call, takeLatest, select } from 'redux-saga/effects';

import { getInterestByCommunity } from 'services/community';
import { AsyncAction } from 'types/Action';
import {
  GetInterestByCommunityMeta,
  GetInterestByCommunityPayload,
} from 'types/store/GetInterestByCommunityState';
import { Store } from 'types/store/Store';

import { getInterestByCommunityActions } from '../actions';

function* getInterestByCommunityRequest(
  action: AsyncAction<GetInterestByCommunityMeta, GetInterestByCommunityPayload>
) {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        getInterestByCommunity,
        action.meta,
        state.auth.token
      );
      yield put(getInterestByCommunityActions.success(data));
      // yield put(getPagesbyCompanyIdActions.success(data));
    } catch (e: any) {
      // yield put(getPagesbyCompanyIdActions.failed(e.message));
    }
  } else {
    // yield put(getPagesbyCompanyIdActions.failed('Token not found'));
  }
}

//   function* forgotPasswordSuccess(action: AsyncAction<ForgotPasswordMeta, ForgotPasswordPayload>) {
//     yield put(push(EMPLOYER_ROUTES.LOGIN));
//   }

function* getInterestByCommunityWatcher(): any {
  yield takeLatest(
    getInterestByCommunityActions.REQUEST,
    getInterestByCommunityRequest
  );
  // yield takeLatest(forgotPasswordActions.SUCCESS, forgotPasswordSuccess);
}

export default getInterestByCommunityWatcher;
